import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginCard } from "../components/Auth";
import { useDocumentTitle } from "../components/ui";
import { useAuth } from "../lib/auth";
import { useT } from "../i18n";

export function LoginPage() {
  const t = useT();
  useDocumentTitle(t("Đăng nhập", "Sign in"));
  const auth = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  useEffect(() => {
    // Chỉ cho phép quay về đường dẫn nội bộ.
    if (auth.status === "authed") navigate(next?.startsWith("/") && !next.startsWith("//") ? next : "/", { replace: true });
  }, [auth.status, next, navigate]);
  return <LoginCard />;
}
